import { InAppReview } from "@capacitor-community/in-app-review";
import { Capacitor } from '@capacitor/core';

export const requestReview = async () => {
  // Only proceed on iOS and Android platforms
  if (Capacitor.getPlatform() === 'web') {
    console.log('In-app review is not available on web platform');
    return;
  }
  
  try {
    const result = await InAppReview.requestReview();
    console.log("Review request result:", result);
  } catch (error) {
    console.error("Error requesting in-app review:", error);
  }
};
